import {getDatadogRum} from 'utils/datadog';
import {getDatadogSessionId} from 'utils/datadog';

export const buildSupportEmailMessage = ({
  subject = 'TRACK Support',
  user = {},
  error = null,
  message = '',
}) => {
  const sessionId = getDatadogSessionId();

  const parts = [
    'Hi!',
    '',
    message || 'A user has requested assistance in TRACK.',
    '',
    `User details:\n${JSON.stringify(user, null, 2)}`,
  ];

  if (error) {
    parts.push('', `Error details:\n${JSON.stringify(error, null, 2)}`);
  }

  if (sessionId) {
    parts.push(
      '',
      `Datadog session ID: ${sessionId}`,
      '',
      `Datadog session URL: https://app.datadoghq.com/rum/sessions?query=%40type%3Asession%20%40session.id%3A${sessionId}`
    );
  } else {
    // Explicit message when session ID is unavailable
    parts.push(
      '',
      'Datadog session ID: Not available (session not initialized or in development mode)',
      'Note: Support staff can still investigate using timestamp and user details above.'
    );
  }

  parts.push('', 'Thank you!');

  return {
    subject,
    body: parts.join('\n'),
  };
};

export const sendSupportEmail = ({subject, body}) => {
  const mailtoLink = `mailto:itsupport@uncommonschools.org?subject=${encodeURIComponent(
    subject
  )}&body=${encodeURIComponent(body)}`;
  window.location.href = mailtoLink;

  const rum = getDatadogRum();
  if (rum) {
    rum.addAction('support_email_sent', {
      subject,
      body,
    });
  }
};
